import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDeleteScrapRule } from '../hooks/useDeleteScrapRule'

interface ModalDeleteScrapRuleProps {
  scrapRuleId?: string
  onError?: (error: ErrorResponse) => void
}

export const ModalDeleteScrapRule = ({ scrapRuleId, onError }: ModalDeleteScrapRuleProps) => {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const [isOpen, setIsOpen] = useState(false)

  const onSuccess = () => {
    setIsOpen(false)
    queryClient.invalidateQueries({ queryKey: ['scrapRule', scrapRuleId] })
    queryClient.invalidateQueries({ queryKey: ['scrapRules'] })
    navigate(`/maintenance-scrap-rules`)
  }

  const { mutate: deleteScrapRule, isPending: deleteScrapRuleIsPending } = useDeleteScrapRule({
    onSuccess,
    onError: (error) => {
      setIsOpen(false)
      onError?.(error)
    },
  })

  return (
    <Modal
      Trigger={
        <Button operationKlassToCheckPermission='Client::Maintenance::ScrapRules::Destroy' type="button" variant="outline-error">
          Deletar
        </Button>
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Você tem certeza?"
      showClose={false}
      useCancellableFooter
      confirmButtonText="Deletar regra"
      disabled={deleteScrapRuleIsPending}
      onConfirm={() => deleteScrapRule(scrapRuleId)}
    />
  )
}
